/* eslint-disable */

import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import { resources } from './resources';

export const DEFAULT_LOCALE = 'en-US';

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: process.env.LOCALE,
    fallbackLng: DEFAULT_LOCALE,
    interpolation: {
      escapeValue: false,
    },
    returnNull: false,
    /**
     * From i18next v21, the v4 JSON format is being used by default, which would require changes within localization messages
     * see https://www.i18next.com/translation-function/plurals
     * */
    compatibilityJSON: 'v3',
  });

export default i18n;
